import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { ScriptEngine } from '../main/models/request';
import { SavedScriptInfo } from '../main/models/saved-script';

/**
 * The "Use a saved script" dropdown's data source - `GET /saved-scripts?engine=...`
 * (`SavedScriptController`, jit-service). Visibility is server-side (bucket `CAN_VIEW`), so this
 * list is already exactly what the caller is allowed to reuse - no client-side filtering needed.
 */
@Injectable({
  providedIn: 'root',
})
export class SavedScriptService {

  private url: string;

  constructor(private http: HttpClient) {
    this.url = environment.slideCropServer;
  }

  private join(path: string): string {
    const base = this.url.endsWith('/') ? this.url : `${this.url}/`;
    const p = path.startsWith('/') ? path.substring(1) : path;
    return `${base}${p}`;
  }

  public list(engine: ScriptEngine): Observable<SavedScriptInfo[]> {
    const url = new URL(this.join('saved-scripts'), window.location.origin);
    url.searchParams.set('engine', engine);
    return this.http.get<SavedScriptInfo[]>(url.toString());
  }
}
